import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@material-ui/core';

import { FEATURE_FLAG_NAMES } from 'yeself-common/typings/FeatureFlags';

import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        'border-right': '1px solid #ccc',
        [theme.breakpoints.down('sm')]: {
            'border-right': 0,
        },
    },
    navLink: {
        display: 'flex',
        textDecoration: 'none',
        '& :hover': {
            'background-color': theme.palette.hoverBackground.backgroundColor,
        },
    },
    navLinkActive: {
        'background-color': theme.palette.hoverBackground.backgroundColor,
    },
    listItem: {
        'padding-left': 10,
        '& :hover': {
            'background-color': 'unset',
        },
        [theme.breakpoints.down('sm')]: {
            'padding-left': 24,
        },
    },
    listItemText: {
        color: theme.palette.sixth.color,
        'font-size': 14,
        'line-height': 1,
        '& :hover': {
            'background-color': 'unset',
        },
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
});

const NavSider = ({ classes, intl, routePrefix, isRoleOrganizationAdmin, featureFlags }) => {
    const { formatMessage } = intl;
    const listItems = [
        {
            navLinkTo: ROUTES.SETTINGS_GENERAL,
            displayName: formatMessage({
                id: 'Settings.navigation.general',
            }),
        },
        // {
        //     navLinkTo: ROUTES.SETTINGS_SECURITY,
        //     displayName: formatMessage({
        //         id: 'Settings.navigation.security'
        //     })
        // },
    ];

    if (featureFlags[FEATURE_FLAG_NAMES.INTEGRATIONS]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_INTEGRATION,
            displayName: formatMessage({
                id: 'Settings.navigation.integration',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.LANGUAGE]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_LANGUAGE,
            displayName: formatMessage({
                id: 'Settings.navigation.language',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.IDENTITY]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_IDENTITY,
            displayName: formatMessage({
                id: 'Settings.navigation.identity',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.GUIDE_DEFAULTS]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_GUIDE_DEFAULTS,
            displayName: formatMessage({
                id: 'Settings.navigation.guideDefaults',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.CONFUSION]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_CONFUSION,
            displayName: formatMessage({
                id: 'Settings.navigation.confusion',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.AUDIENCE]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_AUDIENCE,
            displayName: formatMessage({
                id: 'Settings.navigation.audience',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.TRACKING]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_TRACKING,
            displayName: formatMessage({
                id: 'Settings.navigation.tracking',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.THEME]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_THEME,
            displayName: formatMessage({
                id: 'Settings.navigation.theme',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.SELECTOR_SYSTEM]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_SELECTOR_SYSTEM,
            displayName: formatMessage({
                id: 'Settings.navigation.selectorSystem',
            }),
        });
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_SELECTOR_DEFAULTS,
            displayName: formatMessage({
                id: 'Settings.navigation.selectorDefaults',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.MULTI_TENANCY]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_MULTITENANCY,
            displayName: formatMessage({
                id: 'Settings.navigation.multitenancy',
            }),
        });
    }

    if (featureFlags[FEATURE_FLAG_NAMES.ACCESS]) {
        if (isRoleOrganizationAdmin) {
            listItems.push({
                navLinkTo: ROUTES.SETTINGS_ACCESS,
                displayName: formatMessage({
                    id: 'Settings.navigation.access',
                }),
            });
        }
    }

    if (featureFlags[FEATURE_FLAG_NAMES.ADD_ONS]) {
        listItems.push({
            navLinkTo: ROUTES.SETTINGS_ADD_ONS,
            displayName: formatMessage({
                id: 'Settings.navigation.addOns',
            }),
        });
    }

    return (
        <List id="yeself-nav-sider" className={classes.root} component="nav">
            {listItems.map((item) => (
                <NavLink
                    id="yeself-nav-sider-navlink-item"
                    key={`setting-sidebar-navlink-item-${item.displayName}`}
                    className={classes.navLink}
                    to={`${routePrefix}${item.navLinkTo}`}
                    activeClassName={classes.navLinkActive}
                >
                    <ListItem
                        id="yeself-nav-sider-item"
                        key={`setting-sidebar-item-${item.displayName}`}
                        className={classes.listItem}
                        button
                    >
                        <ListItemText
                            primaryTypographyProps={{ className: classes.listItemText }}
                            primary={item.displayName}
                        />
                    </ListItem>
                </NavLink>
            ))}
        </List>
    );
};

export default withStyles(styles)(NavSider);
